import { Box, Card, CardContent, CardMedia, Grid, Typography, Chip } from '@mui/material'
import ReusableHeadingComponents from '../../components/reusableComponents/reusableHeadingComponents'
import ReusableBtn from '../../components/reusableComponents/ReusableBtn'
import ReusableMuiIcons from '../../_helpers/ReusableMuiIcons'
import cardImage from '../../img-offer/cardImage.png';
import spotify from '../../img-offer/spotify.svg';
// import { useHistory, useParams } from "react-router-dom";

export default function ViewOverview({ offerDetail }) {

    // const history = useHistory();
    // const { offerId } = useParams();
    const overviewDetails = [
        { title: "Start Date", subtitle: offerDetail?.start_date },
        { title: "End Date", subtitle: offerDetail?.end_date },
        { title: "Available Barter Units", subtitle: offerDetail?.available_units },
        ...(offerDetail?.delivery_time ? [{ title: "Delivery Timeline", subtitle: offerDetail.delivery_time }] : []),
        ...(offerDetail?.url ? [{ title: "Offer URL", subtitle: offerDetail.url, isLink: true }] : [])
    ];


    // const handleEdit = () => {
    //     history.push(`/edit-offer/overview/${offerId}`);
    // };

    return (
        <Box sx={{ padding: 2 }}>
            {/* Header Section */}
            <Box display={'flex'} justifyContent={'space-between'} alignItems={{ xs: 'flex-start', md: 'center' }} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
                <ReusableHeadingComponents heading={'Offer Overview (Assets & Key Details)'} />
                {/* <Box display={'flex'} gap={1} sx={{ paddingBottom: { xs: '10px', md: '0' } }}>
                    <ReusableBtn label="Edit" icon={<ReusableMuiIcons name="edit" />} onClick={handleEdit} disabled={offerDetail?.is_draft === false} />
                </Box> */}
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <Grid container spacing={2} mb={3}>
                        <Grid item xs={12} md={6}>
                            <Card sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                <CardMedia
                                    component="img"
                                    image={offerDetail?.banner}
                                    alt="Feel the Rhythm - Offer image"
                                    sx={{
                                        height: 200,
                                        objectFit: 'cover'
                                    }}
                                />
                            </Card>
                        </Grid>

                        {/* Offer Card */}
                        <Grid item xs={12} md={6}>
                            <Card sx={{
                                height: 200,
                                padding: 3,
                                backgroundColor: '#FFFFFF',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: 2,
                                borderRadius: 2
                            }}>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontSize: '24px',
                                        color: '#1A1A1A',
                                        fontWeight: 600,
                                        lineHeight: 1.2
                                    }}
                                >
                                    {offerDetail?.title}
                                </Typography>
                            </Card>
                        </Grid>
                    </Grid>

                    {/* Offer Description Section */}
                    <Card sx={{ mb: 3, borderRadius: 2 }}>
                        <CardContent sx={{ padding: 3 }}>
                            <Box display={'flex'} alignItems={'center'} gap={1} mb={2}>
                                <Typography variant="h6" sx={{ color: '#7A7A7A', fontSize: '18px', fontWeight: 600 }}>
                                    Offer Description
                                </Typography>
                            </Box>
                            <Typography sx={{ color: '#7A7A7A', fontSize: '16px', fontWeight: 400, lineHeight: 1.5 }} dangerouslySetInnerHTML={{
                                __html: offerDetail?.offer_description || ''
                            }} >
                            </Typography>
                        </CardContent>
                    </Card>

                    {/* Product & Creative Assets Section */}
                    <Card sx={{ borderRadius: 2 }}>
                        <CardContent sx={{ padding: 3 }}>
                            <Typography variant="h6" sx={{ color: '#7A7A7A', fontSize: '18px', fontWeight: 600, paddingBottom: '10px' }}>
                                Product & Creative Assets
                            </Typography>

                            <Grid container spacing={2}>
                                {Array.isArray(offerDetail?.product_images) && offerDetail.product_images.length > 0 ? (
                                    offerDetail.product_images.map((imageObj, index) => (
                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Card
                                                sx={{
                                                    // height: 150,
                                                    backgroundColor: '#F5F5F5',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderRadius: 2,
                                                    overflow: 'hidden',
                                                    // padding: 1,
                                                }}
                                            >
                                                {imageObj.url ? (
                                                    <CardMedia
                                                        // height="150"
                                                        component="img"
                                                        image={imageObj.url}
                                                        alt={`Product Asset ${index + 1}`}
                                                        sx={{ width: "100%", height: "100%", objectFit: 'cover' ,borderRadius: 2}} //contain
                                                    />
                                                ) : (
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            width: '100%',
                                                            height: '100%',
                                                        }}
                                                    >
                                                        <ReusableMuiIcons name="image" sx={{ color: '#999', fontSize: '30px' }} />
                                                    </Box>
                                                )}
                                            </Card>
                                        </Grid>
                                    ))
                                ) : (
                                    // placeholders if no images
                                    [1, 2, 3].map((item) => (
                                        <Grid item xs={12} sm={6} md={4} key={item}>
                                            <Card
                                                sx={{
                                                    height: 150,
                                                    backgroundColor: '#F5F5F5',
                                                    display: 'flex',
                                                    flexDirection: { xs: 'column', md: 'row' },
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    borderRadius: 2,
                                                    padding: 2,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 50,
                                                        height: 50,
                                                        backgroundColor: '#E0E0E0',
                                                        borderRadius: 1,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <ReusableMuiIcons name="image" sx={{ color: '#999', fontSize: '30px' }} />
                                                </Box>
                                            </Card>
                                        </Grid>
                                    ))
                                )}
                            </Grid>



                            <Card sx={{ borderRadius: 2, marginTop: '20px' }}>
                                <CardContent sx={{ padding: 2 }}>
                                    <Box display={'flex'} alignItems={'center'} gap={1} mb={2}>
                                        <Typography variant="h6" sx={{ color: '#7A7A7A', fontSize: '18px', fontWeight: 600 }}>
                                            Product Description
                                        </Typography>
                                    </Box>
                                    <Typography sx={{ color: '#7A7A7A', fontSize: '16px', fontWeight: 400, lineHeight: 1.5 }} dangerouslySetInnerHTML={{
                                        __html: offerDetail?.product_description || ''
                                    }} />
                                </CardContent>
                            </Card>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Right Column - Core Offer Details */}
                <Grid item xs={12} md={4}>
                    <Card sx={{
                        padding: 3,
                        borderRadius: 2,
                        backgroundColor: '#FFFFFF',
                        height: 'fit-content'
                    }}>
                        <Typography
                            sx={{
                                color: '#7A7A7A',
                                fontSize: '18px',
                                fontWeight: 600,
                                mb: 3
                            }}
                        >
                            Core Offer Details
                        </Typography>

                        <Box display={'flex'} flexDirection={'column'} gap={2}>
                            {overviewDetails.map((detail, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        border: '1px solid #E0E0E0',
                                        borderRadius: 2,
                                        boxShadow: 'none'
                                    }}
                                >
                                    <CardContent sx={{ padding: '16px !important' }}>
                                        <Typography
                                            sx={{
                                                fontSize: '14px',
                                                color: '#7A7A7A',
                                                fontWeight: 600,
                                                mb: 1
                                            }}
                                        >
                                            {detail.title}
                                        </Typography>
                                        {detail.isLink ? (
                                            <a
                                                href={detail.subtitle}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    fontSize: '14px',
                                                    color: '#2196F3',
                                                    fontWeight: 500,
                                                    textDecoration: 'underline',
                                                    wordBreak: 'break-all'
                                                }}
                                            >
                                                {detail.subtitle}
                                            </a>
                                        ) : (
                                            <Typography
                                                sx={{
                                                    fontSize: '14px',
                                                    color: '#A6A6A6',
                                                    fontWeight: 500,
                                                    wordBreak: 'break-all'
                                                }}
                                            >
                                                {detail.subtitle}
                                            </Typography>
                                        )}

                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </Card>
                </Grid>
            </Grid>

        </Box>
    )
}